import { render, staticRenderFns } from "./RoomCard.vue?vue&type=template&id=6afdb143&scoped=true&"
import script from "./RoomCard.vue?vue&type=script&lang=js&"
export * from "./RoomCard.vue?vue&type=script&lang=js&"
import style0 from "./RoomCard.vue?vue&type=style&index=0&id=6afdb143&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afdb143",
  null
  
)

export default component.exports